import api from './api';
import { LoginData } from 'pages/LoginPage';

export interface User {
  id: string;
  name: string;
  email: string;
  role: 'super_admin' | 'admin' | 'researcher' | 'contributor';
  status: 'active' | 'pending_approval' | 'suspended';
}

export interface RegisterData {
  name: string;
  email: string;
  password: string;
  password_confirm: string;
  demo_request: boolean;
  country?: string;
  sector?: string;
}

interface TokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export const login = async (data: LoginData): Promise<TokenResponse> => {
  // Convert email to username for OAuth2PasswordRequestForm
  const formData = new FormData();
  formData.append('username', data.email);
  formData.append('password', data.password);
  
  const response = await api.post('/auth/login', formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
  return response.data;
};

export const getCurrentUser = async (): Promise<User> => {
  const response = await api.get('/auth/me');
  return response.data;
};

export const register = async (data: RegisterData): Promise<User> => {
  const response = await api.post('/auth/register', data);
  return response.data;
};

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  new_password: string;
}

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

export const forgotPassword = async (data: ForgotPasswordRequest): Promise<{ message: string }> => {
  const response = await api.post('/auth/forgot-password', data);
  return response.data;
};

export const resetPassword = async (data: ResetPasswordRequest): Promise<{ message: string }> => {
  const response = await api.post('/auth/reset-password', data);
  return response.data;
};

export const changePassword = async (data: ChangePasswordRequest): Promise<{ message: string }> => {
  const response = await api.post('/auth/change-password', data);
  return response.data;
};